import type { Role } from '@/types'
import { areasForRole, isPortalType, type FinanceAreaKey } from './financeSolicitacoesConfig'

/** Férias / ausência (P6) — também na área Comercial para closers e BDRs. */
export const COMERCIAL_SHARED_PORTAL_TYPE_KEYS = ['P6_NOVA'] as const

export type PortalTypeRow = {
  key: string
  area: FinanceAreaKey
  mvp?: boolean
  portal?: boolean
}

export function isPortalTypeVisibleForRole(role: Role, type: PortalTypeRow): boolean {
  if (!isPortalType(type.key)) return false
  if (!(type.portal || type.mvp)) return false

  const areas = areasForRole(role)
  if (areas.includes(type.area)) return true

  return (
    (role === 'closer' || role === 'bdr') &&
    (COMERCIAL_SHARED_PORTAL_TYPE_KEYS as readonly string[]).includes(type.key)
  )
}

/** Onde o card aparece no hub do portal (comercial enxerga P6 na área Comercial). */
export function portalHubAreaForType(role: Role, type: PortalTypeRow): FinanceAreaKey {
  if (
    (role === 'closer' || role === 'bdr') &&
    type.key === 'P6_NOVA'
  ) {
    return 'COMERCIAL'
  }
  return type.area
}

export function buildPortalTypesByArea<T extends PortalTypeRow>(
  role: Role,
  types: T[],
  extraFilter?: (type: T) => boolean,
): Map<FinanceAreaKey, T[]> {
  const map = new Map<FinanceAreaKey, T[]>()
  for (const area of areasForRole(role)) map.set(area, [])

  for (const type of types) {
    if (!isPortalTypeVisibleForRole(role, type)) continue
    if (extraFilter && !extraFilter(type)) continue
    const hubArea = portalHubAreaForType(role, type)
    map.get(hubArea)?.push(type)
  }

  return map
}
